// Subscription plan catalogue. Each plan exposes the raw limits via the
// `limits` field so the backend can enforce quotas, while the derived fields
// (`charLimit`, `projectLimit`, …) keep backwards compatibility with the
// existing UI.

const UNLIMITED = Number.MAX_SAFE_INTEGER;
const GB = 1024 * 1024 * 1024;

const createPlan = ({ label, limits, support, aiTools }) => {
    const normalizedLimits = {
        characters: limits.characters ?? UNLIMITED,
        projects: limits.projects ?? UNLIMITED,
        teamMembers: limits.teamMembers ?? UNLIMITED,
        targetLanguages: limits.targetLanguages ?? UNLIMITED,
        storageBytes: limits.storageBytes ?? UNLIMITED,
    };

    return {
        label,
        limits: normalizedLimits,
        support,
        aiTools: aiTools ?? false,
        // Backwards compatible aliases used across the application today
        charLimit: normalizedLimits.characters,
        projectLimit: normalizedLimits.projects,
        teamLimit: normalizedLimits.teamMembers,
        maxTargetLanguages: normalizedLimits.targetLanguages,
        storageLimit: normalizedLimits.storageBytes,
    };
};

const ACCOUNT_PLANS = {
    free: createPlan({
        label: 'Free',
        limits: {
            characters: 20_000,
            projects: 5,
            teamMembers: 1,
            targetLanguages: 5,
            storageBytes: 1 * GB,
        },
        support: 'email',
        aiTools: true,
    }),
    essential: createPlan({
        label: 'Essential',
        limits: {
            characters: 100_000,
            projects: 20,
            teamMembers: 1,
            targetLanguages: 25,
            storageBytes: 15 * GB,
        },
        support: 'email',
        aiTools: true,
    }),
    growth: createPlan({
        label: 'Growth',
        limits: {
            characters: 500_000,
            projects: UNLIMITED,
            teamMembers: 10,
            targetLanguages: 100,
            storageBytes: 50 * GB,
        },
        support: 'premium',
        aiTools: true,
    }),
    scale: createPlan({
        label: 'Scale',
        limits: {
            characters: UNLIMITED,
            projects: UNLIMITED,
            teamMembers: UNLIMITED,
            targetLanguages: UNLIMITED,
            storageBytes: UNLIMITED,
        },
        support: 'dedicated',
        aiTools: true,
    }),
};

module.exports = ACCOUNT_PLANS;
